module.exports = __webpack_public_path__ + "images/shop/favicon-carpardoo/favicon-16x16.png";